const LOCAL_HOST = 'localhost';
const DES_PREFIX = 'des-cmsmgspa';
const PRE_PREFIX = 'pre-cmsmgspa';

export function getEnvironmentFromHost(): string {
  const host = window.location.hostname;
  if (host.startsWith(LOCAL_HOST)) {
    return 'LOCAL';
  }

  if (host.startsWith(DES_PREFIX)) {
    return 'DES';
  }

  if (host.startsWith(PRE_PREFIX)) {
    return 'PRE';
  }

  return 'PRO';
}
